<div *ngIf="create" style="padding: 20px">
  <div *ngIf="opmPartners && opmPartners.length > 0">
    <p-select
      ngDefaultControl
      [options]="opmPartners"
      [placeholder]="'partner' | translation"
      [(ngModel)]="partnerId"
      optionLabel="name"
      optionValue="id"
      (onChange)="getNewView()"
    />
  </div>
  <app-view
    [info]="create_info"
    [items]="create?.data?.content"
    [data]="create_data"
  ></app-view>
  <div style="text-align: right">
    <button pButton severity="primary" (click)="submitForm()" [disabled]="!viewLoaded || hasErrors()">{{'create'| translation}}</button>
  </div>
</div>
